module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1224.0ca766a7.png";